import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Story from "@/components/site/Story";
import Varieties from "@/components/site/Varieties";
import WhyUs from "@/components/site/WhyUs";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import Footer from "@/components/site/Footer";
import FloatingWhatsapp from "@/components/site/FloatingWhatsapp";

const Home = () => (
  <div className="App min-h-screen bg-brand-base text-brand-primary font-body">
    <Header />
    <main>
      <Hero />
      <Story />
      <Varieties />
      <WhyUs />
      <Process />
      <Testimonials />
    </main>
    <Footer />
    <FloatingWhatsapp />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
